import React, { useState, useEffect, useRef, useContext } from 'react';
import DealsDataGrid from '../../components/Deals/Page/DealsDataGrid';
import FilterComponent from '../../components/Deals/Page/FilterComponent';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { grey } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import ActionsButton from '../../components/Deals/Page/ActionsButton';
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { AuthContext } from '../../context/AuthContext';

const DealsPage = () => {
  //const [filters, setFilters] = useState([]);
  const { userInfo } = useContext(AuthContext);
  const [filters, setFilters] = useState(() => {
    const savedFilters = localStorage.getItem('dealsFilters');
    return savedFilters ? JSON.parse(savedFilters) : [];
  });
  const apiRef = useRef(null);

  useEffect(() => {
    if (filters.length >= 0) {
      localStorage.setItem('dealsFilters', JSON.stringify(filters));
    }
  }, [filters]);

  const [triggerFetch, setTriggerFetch] = useState(false); // when deleting a row, refetching the data in datagrid
  const [selectedRows, setSelectedRows] = useState([]); // State to store selected row IDs

  // Function to handle row selection
  const handleSelectionChange = (newSelection) => {
    setSelectedRows(newSelection); // Store selected row IDs
  };

  useEffect(() => {
    document.title = "Deals - iLead CRM";
  }, []);

  return (<>
    <Box sx={{ p: 2, height: '100%', display: 'flex' }}>
      <Grid container spacing={2} sx={{ height: '100%' }}>
        <Grid item xs={2.7} sx={{ height: '100%' }}>
          <Paper elevation={3} sx={{ height: 'calc(100vh - 105px)', p: 1, display: 'flex', flexDirection: 'column' }}>
            {/* Ensure FilterComponent also takes full height */}
            <FilterComponent filters={filters} setFilters={setFilters} sx={{ flex: 1, overflow: 'auto' }} />
          </Paper>
        </Grid>

        <Grid item xs={9.3} sx={{ height: '100%' }}>
          <Paper
            elevation={3}
            sx={{
              height: 'calc(100vh - 105px)',
              display: 'flex',
              flexDirection: 'column',
              p: 1,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '8px',
              }}
            >
              <h3>Deals</h3>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Link to="/deals/create">
                  <Button variant="contained" type="submit">Create Deal</Button>
                </Link>
                <ActionsButton itemIds={selectedRows} setSelectedRows={setSelectedRows} setTriggerFetch={setTriggerFetch} />
                {userInfo?.roles?.includes("Admin") && (
                  <Button
                    variant="outlined"
                    startIcon={<FileDownloadIcon />}
                    onClick={() => apiRef.current?.exportDataAsCsv()}
                  >
                    Export
                  </Button>
                )}
              </Box>
            </Box>

            <Box sx={{ flex: 1, overflow: 'hidden' }}>
              <DealsDataGrid
                filters={filters}
                selectedRows={selectedRows}
                triggerFetch={triggerFetch}
                setTriggerFetch={setTriggerFetch}
                onSelectionModelChange={handleSelectionChange}
                apiRef={apiRef} />
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>

  </>
  )
};

export default DealsPage;
